import type { TrackingEvent } from '../../types';

/**
 * Internal tracking events that also get a ChatGPT Ads Conversions API copy.
 *
 * Kept in step with the Meta server-forward allowlist so both vendors receive
 * the same conversions. High-volume browsing events with no campaign objective
 * (`ViewProduct`, `PerformSearch`) stay browser-only.
 */
const SERVER_FORWARDED_EVENTS = new Set<TrackingEvent>([
    'PageView',
    'CreatedEnquiry',
    'EnquiryReveal',
    'EnquiryEngagement',
    'PhoneReveal',
    'BookConsultationReveal',
    'HDESubmission',
    'Website',
    'DownloadsClick',
    'DownloadsLoggedOutClick',
    'SaveSubmit',
    'AddToCart',
    'InitiateCheckout',
    'Purchase',
]);

/**
 * Whether this internal event should also be reported to ChatGPT Ads from the
 * server.
 */
export function isOpenAiServerForwardedEvent(event: TrackingEvent): boolean {
    return SERVER_FORWARDED_EVENTS.has(event);
}
